import React from 'react';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import customTheme from 'commonComponents/whiteTheme';

const styles = {
  label: {
    fontWeight: 300
  }
};

const CustomTextField = ({ classes, ...props }) => (
  <MuiThemeProvider
    theme={
      createMuiTheme({
        ...customTheme
      })
    }
  >
    <TextField
      { ...props }
      InputLabelProps={ {
        classes: {
          root: classes.label
        }
      } }
    />
  </MuiThemeProvider>
);

export default withStyles(styles)(CustomTextField);
